import type { EctdCoverRow } from '@/features/dossier/api';
import { Placeholder, withInlinePlaceholders } from './DossierPrimitives';

/** The EU CTD's identity: the cover rows the server builds for the Word file too
 *  (`eu_front_matter.eu_ctd_front_matter`), one cell per row; a value not on file is a
 *  "Submitter must complete" chip with the row's to-do. Mirrors CombinedIdentityCard. */
export function CtdIdentityCard({ rows }: { rows: EctdCoverRow[] }) {
  return (
    <section
      aria-label="Dossier identity"
      className="bg-white border border-line rounded-2xl p-6 shadow-card mt-4"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {rows.map((row) => (
          <div key={row.label} className="bg-surface-muted rounded-md py-2.5 px-3">
            <div className="text-[10px] uppercase tracking-[0.12em] font-bold text-muted mb-0.5">
              {row.label}
            </div>
            <div className="text-[13px] text-navy">
              {/* A stated value may carry a placeholder for a missing detail — shown as a chip. */}
              {row.value ? withInlinePlaceholders(row.value) : <Placeholder hint={row.todo ?? ''} />}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
